import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledHeader = styled.div`
    padding: 20px 24px;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledSubtitle = styled.p`
    ${mixins.setFontVariant("chip1", colorsPalettes.carbon[400])};
    line-height: 16px;
    margin: 8px 0 0;
`;

export const StyledTitle = styled.h2`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
    line-height: 24px;
    margin: 0;
`;

export const StyledMainContainer = styled.div`
    flex-grow: 1;
    padding: 12px 24px 24px;
`;

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;

    & > *:not(:first-child) {
        margin-left: 4px;
    }
`;

export const StyledDDContent = styled(FlexRow)`
    justify-content: flex-start;
    width: 100%;
`;

export const StyledContainerWithChips = styled(FlexColumn)<{ hasChips?: boolean }>`
    margin-top: ${({ hasChips }) => (!hasChips ? ` 60px` : "12px")};
    width: 100%;
`;

export const StyledOperationContainer = styled.div`
    display: flex;
    width: 77px;
    margin-right: 8px;
`;
